import { FC, ReactNode } from 'react';

import styles from './styles.module.scss';

export const MainLayout: FC<{ children: ReactNode }> = ({ children }) => {
  return <div className={styles.mainLayout}>{children}</div>;
};
